"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDealInfo = void 0;
var chance_1 = require("../chance");
var chance = (0, chance_1.getChance)();
var createDealInfo = function () { return ({
    currency: chance.pickone(['USD', 'UAH']),
    enabled: true,
    period: 72,
    price: chance.natural({ min: 1, max: 100 }),
    type: 'subscription',
}); };
exports.createDealInfo = createDealInfo;
//# sourceMappingURL=_deal-info.js.map